export default __webpack_public_path__ + "static/media/github.566c7bed.svg";